import React from 'react'
import { Box, Flex, Heading, Image, Link, Text } from '@chakra-ui/react'
import { NewsItemProps } from '../types'
import { formatDate } from '../utils'

const NewsItemCard: React.FC<NewsItemProps> = ({ news, bg }) => {
  return (
    <Box
      bg={bg}
      borderRadius="md"
      overflow="hidden"
      shadow="sm"
    >
      {news.image && (
        <Image
          alt={news.headline}
          height="180px"
          objectFit="cover"
          src={news.image}
          width="100%"
        />
      )}
      <Box p={4}>
        <Link
          href={news.url}
          isExternal
          _hover={{ textDecoration: 'none' }}
        >
          <Heading
            as="h4"
            fontSize="md"
            lineHeight="tight"
            mb={2}
            noOfLines={2}
          >
            {news.headline}
          </Heading>
        </Link>
        <Text
          color="gray.600"
          fontSize="sm"
          mb={2}
          noOfLines={3}
        >
          {news.summary}
        </Text>
        <Flex
          align="center"
          color="gray.500"
          fontSize="xs"
          justify="space-between"
          mt={2}
        >
          <Text fontWeight="bold">{news.source}</Text>
          <Text>{formatDate(news.datetime)}</Text>
        </Flex>
      </Box>
    </Box>
  )
}

export default NewsItemCard
